import { LoadingButton } from "@mui/lab";
import { Button, Stack } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import DialogContext from "../../../context";
import useSaveAppConfig from "../../../services/useSaveAppConfig";
import Context from "../context";

// ----------------------------------------------------------------------

export const FooterBtn = () => {
	const { entitiesSelected } = useContext(Context);
	const { actions } = useContext(DialogContext);

	const { isLoading, onChangeAppConfig } = useSaveAppConfig();

	const { translate } = useLocales();

	return (
		<Stack sx={{ mt: 3, flexDirection: "row", justifyContent: "flex-end" }} gap={3}>
			<Button variant='outlined' color='inherit' onClick={actions.hideSelectEntitiesDialog}>
				{translate("app_config.cancel")}
			</Button>
			<LoadingButton
				variant='contained'
				disabled={entitiesSelected.length === 0}
				loading={isLoading}
				onClick={onChangeAppConfig}
			>
				{translate("app_config.save")}
			</LoadingButton>
		</Stack>
	);
};

export default FooterBtn;
